module.exports = __webpack_public_path__ + "static/gallery-6-b63934b2134fa2a6b38525455439be6f.jpg";